import type { ReactNode } from "react";
import { Avatar } from "@mui/material";
import { useUser } from "@sdeapps/react-core";

function getInitials(name: string): string {
  const names = name.split(" ");
  const initials =
    names[0].substring(0, 1).toLocaleUpperCase() +
    (names.at(-1)?.substring(0, 1).toLocaleUpperCase() ?? "");

  return initials;
}

function UserAvatar(): ReactNode {
  const { user } = useUser();

  return (
    <Avatar alt={user.displayName} src={user.avatar}>
      {getInitials(user.displayName)}
    </Avatar>
  );
}

export default UserAvatar;
